import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=57e5d7c6&"
import script from "./Material.vue?vue&type=script&lang=js&"
export * from "./Material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports